import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { GameBase } from '../../games/game-base';
import { BaccaratTableComponent } from '../../games/game-types/baccarat/baccarat-table.component';
import { DragonTigerTableComponent } from '../../games/game-types/dragon-tiger/dragon-tiger-table.component';
import { ThreeHeadedDragonTableComponent } from '../../games/game-types/three-headed-dragon/three-headed-dragon-table.component';
import { GameType } from '../../models/communication/app-enums.model';

@Component({
    selector: 'app-game-switch',
    imports: [CommonModule, DragonTigerTableComponent, BaccaratTableComponent, ThreeHeadedDragonTableComponent],
    templateUrl: './game-switch.component.html',
    styleUrl: './game-switch.component.scss'
})
export class GameSwitchComponent implements OnInit {
    @Input()
    gameInstance?: GameBase;
    @Input() isVoid = false;

    protected readonly GameType = GameType;

    ngOnInit(): void {
        if (!this.gameInstance) {
            // eslint-disable-next-line no-console
            console.error('gameInstance not provided');
        }
    }
}
